var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "orderLists shadow-2 radius-18" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "radius-18 radius-top-0 pb-20" },
      _vm._l(_vm.orders, function (order) {
        return _c(
          "li",
          {
            key: order.id,
            staticClass:
              "orderList p-20 bg-white border-bottom-grey3 cursor-pointer",
            class: { current: _vm.current && _vm.current.id == order.id },
            on: {
              click: function ($event) {
                return _vm.$emit("set-current", order)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "orderList--content flex-between-center w-100 color-grey1",
              },
              [
                _c("div", { staticClass: "orderList--shop--block" }, [
                  order.shop.info.salon && order.shop.info.salon.active
                    ? _c("div", { staticClass: "flex-start-center" }, [
                        _c(
                          "div",
                          { staticClass: "flex-column mr-10 text-nowrap" },
                          [
                            _c("div", [
                              _vm._v(
                                "Nom: " +
                                  _vm._s(order.info2.firstName) +
                                  " " +
                                  _vm._s(order.info2.lastName)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Société: " + _vm._s(order.info2.company) + " "
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _c("div", { staticClass: "flex-start-center" }, [
                        order.shop.Logo
                          ? _c("img", {
                              staticClass:
                                "img-fit mr-10 radius-circle border-grey3",
                              attrs: {
                                src: _vm.UrlService.imagePath(
                                  order.shop.ShopId,
                                  order.shop.Logo
                                ),
                                alt: order.shop.DefaultName,
                                width: "30",
                                height: "30",
                              },
                              on: {
                                error: function ($event) {
                                  $event.target.src = "dist/assets/no-img.png"
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !order.shop.Logo
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "noPic flex-center-center mr-10 bg-grey3",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(order.shop.DefaultName[0]) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-truncate" }, [
                          _vm._v(_vm._s(order.shop.DefaultName)),
                        ]),
                      ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "orderList--id--block" }, [
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        order.OrderId.toLocaleString("en").replaceAll(",", "-")
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "orderList--type--block" }, [
                  order.SaleAreaId == 1
                    ? _c("div", { staticClass: "flex-start-start" }, [
                        _c("div", { staticClass: "tagIcon-bo-s1" }, [
                          _c("i", { staticClass: "fie-icon_store" }),
                          _c("span", [_vm._v("Table " + _vm._s(order.Table))]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  order.SaleAreaId == 2
                    ? _c("div", { staticClass: "flex-start-start" }, [
                        _vm._m(1, true),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  order.SaleAreaId == 3
                    ? _c("div", { staticClass: "flex-start-start" }, [
                        _vm._m(2, true),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  order.SaleAreaId == 4
                    ? _c("div", { staticClass: "flex-start-start" }, [
                        !order.stuart_job_id
                          ? _c("div", { staticClass: "tagIcon-bo-p1" }, [
                              _c("i", { staticClass: "fie-icon_delivery" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Livraison")]),
                            ])
                          : _c(
                              "a",
                              {
                                staticClass:
                                  "tagIcon-bo-p1 color-bo-p1 hover-color-bo-p1 hover-opacity",
                                attrs: {
                                  target: "_blank",
                                  href: _vm.StuartSevice.getLinkToJob(
                                    order.stuart_job_id,
                                    order.shop
                                  ),
                                },
                              },
                              [
                                _c("i", { staticClass: "fie-icon_delivery" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Livraison")]),
                              ]
                            ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "orderList--date--block" }, [
                  _c("div", [_vm._v(_vm._s(_vm.ago(order.date)))]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "orderList--status--block" },
                  [
                    _c("div", { staticClass: "orderList--status--pills" }, [
                      order.OrderState == -1
                        ? _c(
                            "div",
                            { staticClass: "pill text-white bg-bo-p1" },
                            [_vm._v("Non confirmé")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      order.OrderState == -4
                        ? _c(
                            "div",
                            { staticClass: "pill text-white bg-bo-p2" },
                            [_vm._v("En attente")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      order.OrderState == 0
                        ? _c(
                            "div",
                            { staticClass: "pill text-white bg-bo-s1" },
                            [_vm._v("En préparation")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      order.OrderState == 1
                        ? _c(
                            "div",
                            { staticClass: "pill text-white bg-bo-s2" },
                            [_vm._v("Confirmé")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      order.OrderState ==
                      _vm.CartService.ORDER_STATES.STATE_CANCELLED
                        ? _c(
                            "div",
                            { staticClass: "pill color-white bg-bo-danger" },
                            [_vm._v("Annulé")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      order.OrderState ==
                      _vm.CartService.ORDER_STATES.STATE_CHARGEBACK
                        ? _c(
                            "div",
                            { staticClass: "pill color-white bg-bo-danger" },
                            [_vm._v("Chargeback")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("deliverect-status", { attrs: { order: order } }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "orderList--payment--block" }, [
                  _c("div", { staticClass: "display-3 text-bold" }, [
                    _vm._v(_vm._s(_vm.ShopService.prix(order.Total))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "orderList--reorder--block" }, [
                  _c("div", { staticClass: "flex-end-start" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btnFlat-color2 small",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.CartService.reorder(order)
                          },
                        },
                      },
                      [_c("span", [_vm._v("Commander à nouveau")])]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "orderLists--thead bg-grey3 color-grey2 fsize-12 text-uppercase flex-between-center p-20",
      },
      [
        _c("div", { staticClass: "orderList--shop" }, [_vm._v("Client")]),
        _vm._v(" "),
        _c("div", { staticClass: "orderList--id" }, [_vm._v("N°")]),
        _vm._v(" "),
        _c("div", { staticClass: "orderList--type" }, [_vm._v("Consommation")]),
        _vm._v(" "),
        _c("div", { staticClass: "orderList--date" }, [_vm._v("Date")]),
        _vm._v(" "),
        _c("div", { staticClass: "orderList--status" }, [_vm._v("Status")]),
        _vm._v(" "),
        _c("div", { staticClass: "orderList--payment" }, [_vm._v("Total")]),
        _vm._v(" "),
        _c("div", { staticClass: "orderList--reorder" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tagIcon-bo-s2" }, [
      _c("i", { staticClass: "fie-icon_on-site" }),
      _c("span", [_vm._v("Sur place")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tagIcon-bo-p2" }, [
      _c("i", { staticClass: "fie-icon_takeaway" }),
      _c("span", [_vm._v("A emporter")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }